/**
 * Created by slava on 4/5/17.
 */

const TestSocial = function () {
    Social.call(this, connector.TEST, {
        sdk: SdkManager.SDK_TEST
    });
};

TestSocial.prototype = Object.create(Social.prototype);
TestSocial.prototype.constructor = TestSocial;

TestSocial.prototype.isShareSupported = function () {
    return true;
};

TestSocial.prototype.isInviteSupported = function () {
    return true;
};

TestSocial.prototype.isSupportsNativeRequest = function () {
    return true;
};

TestSocial.prototype.updateSession = function (id) {
    let expire;
    if (typeof DateShift !== "undefined") {
        expire = new DateShift.Date();
    } else {
        expire = new Date();
    }
    expire.setMonth(expire.getMonth() + 3);

    this.id = id;
    this.token = "123";
    this.expires = expire.getTime();

    document.cookie = `tsid=${this.id}; path=/; expires=${expire.toUTCString()}`;
};

TestSocial.prototype.removeSession = function () {
    this.id = undefined;
    this.token = undefined;
    this.expires = undefined;

    document.cookie = "tsid=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

TestSocial.prototype.loadSession = function () {
    const match = document.cookie && document.cookie.match(/tsid=([^;]+)/);
    if (match) {
        this.updateSession(match[1]); 
    }
};

TestSocial.prototype._connect = function (callback) {
    this.id = undefined;
    this.expires = undefined;
    this.token = undefined;

    setTimeout(() => {
        this.loadSession();
        callback(connector.STATUS_CONNECTED);
    }, 1000);
};

TestSocial.prototype._showTestImage = function (base64Image, callback) {
    const image = new Image();
    document.body.appendChild(image);
    image.style.zIndex = "10";
    image.style.margin = "auto auto";

    const close = function () {
        document.body.removeChild(image);
    };

    image.onload = function () {
        setTimeout(() => {
            callback(connector.CODE_SUCCEED, close);
        }, 100);
    };
    image.src = base64Image;
};

TestSocial.prototype._showTestChooseWindow = function (base64ChooseWindow, callback) {
    const styles = document.createElement("style");
    styles.innerHTML = ""
        + ".test-social-overlay {"
        + "    position: fixed;"
        + "    left: 0;"
        + "    top: 0;"
        + "    right: 0;"
        + "    bottom: 0;"
        + "    background-color: rgba(0, 0, 0, 0.5);"
        + "    z-index: 1000;"
        + "    display: flex;"
        + "    justify-content: center;"
        + "    align-items: center;"
        + "}"
        + ".test-social-form {"
        + "    position: relative;"
        + "    background-color: #fff;"
        + "    padding: 20px;"
        + "    border-radius: 8px;"
        + "    text-align: center;"
        + "    font-size: 18px;"
        + "    display: flex;"
        + "    flex-direction: column;"
        + "    justify-content: center;"
        + "    align-items: center;"
        + "    gap: 20px;"
        + "    max-width: 500px;"
        + "    width: 90%;"
        + "}"
        + ".test-social-friends-list {"
        + "    display: grid;"
        + "    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));"
        + "    gap: 15px;"
        + "    width: 100%;"
        + "    max-height: 400px;"
        + "    overflow-y: auto;"
        + "    padding: 10px;"
        + "}"
        + ".test-social-friend-item {"
        + "    background-color: #f5f5f5;"
        + "    padding: 10px;"
        + "    border-radius: 8px;"
        + "    cursor: pointer;"
        + "    transition: background-color 0.2s;"
        + "}"
        + ".test-social-friend-item:hover {"
        + "    background-color: #e0e0e0;"
        + "}"
        + ".test-social-friend-item.selected {"
        + "    background-color: #007BFF;"
        + "    color: white;"
        + "}"
        + ".test-social-friend-avatar {"
        + "    width: 80px;"
        + "    height: 80px;"
        + "    border-radius: 50%;"
        + "    margin-bottom: 8px;"
        + "}"
        + ".test-social-friend-name {"
        + "    font-size: 14px;"
        + "    word-break: break-word;"
        + "}"
        + "#test-social-close {"
        + "    position: absolute;"
        + "    top: 10px;"
        + "    right: 10px;"
        + "    background-color: transparent;"
        + "    border: none;"
        + "    font-size: 20px;"
        + "    cursor: pointer;"
        + "    color: #aaa;"
        + "}"
        + "#test-social-close:hover {"
        + "    color: #000;"
        + "}"
        + "#test-social-send {"
        + "    background-color: #28A745;"
        + "    color: white;"
        + "    border: none;"
        + "    padding: 10px 20px;"
        + "    border-radius: 4px;"
        + "    cursor: pointer;"
        + "    font-size: 16px;"
        + "}"
        + "#test-social-send:hover {"
        + "    background-color: #218838;"
        + "}"
        + "#test-social-send:disabled {"
        + "    background-color: #ccc;"
        + "    cursor: not-allowed;"
        + "}";
    document.head.appendChild(styles);

    const overlay = document.createElement("div");
    overlay.className = "test-social-overlay";
    document.body.appendChild(overlay);

    let selectedFriend = null;

    const onClose = function () {
        document.body.removeChild(overlay);
        document.head.removeChild(styles);
        callback(connector.CODE_CANCELLED);
    };

    overlay.innerHTML = ""
        + "<div class='test-social-form'>"
        + "    <div>Choose a friend</div>"
        + "    <div class='test-social-friends-list' id='test-social-friends-list'></div>"
        + "    <button id='test-social-send' disabled>Send</button>"
        + "    <button id='test-social-close'>&times;</button>"
        + "</div>";

    const friendsList = document.getElementById("test-social-friends-list");
    const sendButton = document.getElementById("test-social-send");
    const closeButton = document.getElementById("test-social-close");

    Object.values(TestSocial.USERS).forEach((user) => {
        const friendElement = document.createElement("div");
        friendElement.className = "test-social-friend-item";
        friendElement.innerHTML = ""
            + `<img class='test-social-friend-avatar' src='${user.avatar}' alt='${user.name}'>`
            + `<div class='test-social-friend-name'>${user.name}</div>`;

        friendElement.onclick = function () {
            if (selectedFriend) {
                const prevElement = document.querySelector(".test-social-friend-item.selected");
                if (prevElement) {
                    prevElement.classList.remove("selected");
                }
            }

            selectedFriend = user.id;
            friendElement.classList.add("selected");
            sendButton.disabled = false;
        };

        friendsList.appendChild(friendElement);
    });

    sendButton.onclick = function () {
        document.body.removeChild(overlay);
        document.head.removeChild(styles);
        callback(connector.CODE_SUCCEED, [selectedFriend]);
    };

    closeButton.onclick = onClose;
};

TestSocial.prototype.share = function (data, callback) {
    this._showTestImage(data.image, (code, close) => {
        if (code !== connector.CODE_SUCCEED) {
            close();
            callback(code);
            return;
        }

        if (confirm(`Share ${JSON.stringify(data)}?`)) {
            close();

            callback(connector.CODE_SUCCEED);
        } else {
            close();

            callback(connector.CODE_FAILED);
        }
    });
};

TestSocial.prototype.isExpired = function () {
    let now;
    if (typeof DateShift !== "undefined") {
        now = new DateShift.Date();
    } else {
        now = Date.now();
    }

    return !this.expires || this.expires < now;
};

TestSocial.prototype.isLoggedIn = function () {
    return Boolean(this.id);
};

TestSocial.prototype._getUserID = function () {
    return this.id;
};

TestSocial.prototype.getAccessToken = function () {
    return this.isExpired() ? undefined : this.token;
};

TestSocial.prototype._login = function (callback) {
    this._createLoginOverlay((id) => {
        if (id) {
            this.updateSession(id);
        } else {
            this.removeSession();
        }

        callback();
    });
};

TestSocial.prototype.logout = function () {
    this.removeSession();
};

TestSocial.prototype.invite = function (data, callback) {
    this._showTestImage(data.image, (code, close) => {
        if (code !== connector.CODE_SUCCEED) {
            close();
            callback(code);
            return;
        }

        if (confirm(`Invite ${JSON.stringify(data)}`)) {
            close();

            callback(connector.CODE_SUCCEED);
        } else {
            close();

            callback(connector.CODE_FAILED);
        }
    });
};

TestSocial.prototype.request = function (data, callback) {
    delete data.element;

    callback = callback || function () {};

    connector.utils.loadBase64(data.image, (base64Image) => {
        if (base64Image) {
            if (!data.to) {
                this._showTestChooseWindow(base64Image, (code, selectedFriends) => {
                    if (code === connector.CODE_SUCCEED && selectedFriends.length > 0) {
                        this._showTestImage(base64Image, (code, close) => {
                            data.to = selectedFriends;
                            if (confirm(`Request ${JSON.stringify(data)}?`)) {
                                close();
                                callback(connector.CODE_SUCCEED, selectedFriends);
                            } else {
                                close();
                                callback(connector.CODE_FAILED);
                            }
                        });
                    } else {
                        callback(code);
                    }
                });
            } else {
                this._showTestImage(base64Image, (code, close) => {
                    if (code !== connector.CODE_SUCCEED) {
                        close();
                        callback(code);
                        return;
                    }

                    if (confirm(`Request ${JSON.stringify(data)}?`)) {
                        close();
                        callback(connector.CODE_SUCCEED);
                    } else {
                        close();
                        callback(connector.CODE_FAILED);
                    }
                });
            }
        } else {
            callback(connector.CODE_FAILED);
        }
    });
};

TestSocial.prototype._listFriends = function (callback) {
    setTimeout(() => {
        callback(connector.CODE_SUCCEED, Object.values(TestSocial.USERS));
    }, 500);
};

TestSocial.prototype._listInvitableFriends = function (callback) {
    setTimeout(() => {
        callback(connector.CODE_SUCCEED, Object.values(TestSocial.INVITABLE_USERS));
    }, 500);
};

TestSocial.prototype._aboutMe = function (callback) {
    setTimeout(() => {
        const user = TestSocial.USERS[connector.platform.getUserID()];
        if (user) {
            callback(connector.CODE_SUCCEED, user);
        } else {
            callback(connector.CODE_SUCCEED, {
                name: "Ryan Mitchell",
                firstName: "Ryan",
                lastName: "Mitchell",
                avatar: "https://pay.zareefgaming.com/example/avatars/avatar_default.png",
                id: connector.platform.getUserID()
            });
        }
    }, 500);
};

TestSocial.prototype._createLoginOverlay = function (callback) {
    const styles = document.createElement("style");
    styles.innerHTML = ""
        + ".test-social-overlay {"
        + "    position: fixed;"
        + "    left: 0;"
        + "    top: 0;"
        + "    right: 0;"
        + "    bottom: 0;"
        + "    background-color: rgba(0, 0, 0, 0.5);"
        + "    z-index: 1000;"
        + "    display: flex;"
        + "    justify-content: center;"
        + "    align-items: center;"
        + "}"
        + ".test-social-form {"
        + "    position: relative;"
        + "    background-color: #fff;"
        + "    padding: 20px;"
        + "    border-radius: 8px;"
        + "    text-align: center;"
        + "    font-size: 18px;"
        + "    display: flex;"
        + "    flex-direction: column;"
        + "    justify-content: center;"
        + "    align-items: center;"
        + "    gap: 20px;"
        + "}"
        + ".test-social-current-user {"
        + "    font-weight: bold;"
        + "}"
        + ".test-social-choose-user > div:first-child {"
        + "    margin-bottom: 10px;"
        + "}"
        + ".test-social-choose-user > div:last-child {"
        + "    display: flex;"
        + "    justify-content: space-around;"
        + "}"
        + ".test-social-choose-user > div:last-child > div {"
        + "    background-color: #007BFF;"
        + "    color: #fff;"
        + "    padding: 10px;"
        + "    border-radius: 4px;"
        + "    cursor: pointer;"
        + "    flex: 1;"
        + "    margin: 0 5px;"
        + "    text-align: center;"
        + "}"
        + ".test-social-choose-user > div:last-child > div:hover {"
        + "    background-color: #0056b3"
        + "}"
        + ".test-social-custom-user > div:first-child {"
        + "    margin-bottom: 10px;"
        + "}"
        + ".test-social-custom-user input {"
        + "    width: 300px;"
        + "    padding: 8px;"
        + "    border: 1px solid #ccc;"
        + "    border-radius: 4px;"
        + "}"
        + "#test-social-login {"
        + "    width: 240px;"
        + "    background-color: #28A745;"
        + "    color: #fff;"
        + "    padding: 12px;"
        + "    border-radius: 4px;"
        + "    cursor: pointer;"
        + "}"
        + "#test-social-login:hover {"
        + "    background-color: #218838;"
        + "}"
        + "#test-social-close {"
        + "    position: absolute;"
        + "    top: 10px;"
        + "    right: 10px;"
        + "    background-color: transparent;"
        + "    border: none;"
        + "    font-size: 20px;"
        + "    cursor: pointer;"
        + "    color: #aaa;"
        + "}"
        + "#test-social-close:hover {"
        + "    color: #000;"
        + "}";
    document.head.appendChild(styles);

    const overlay = document.createElement("div");
    overlay.className = "test-social-overlay";
    document.body.appendChild(overlay);

    const onLogin = function (id) {
        document.body.removeChild(overlay);
        document.head.removeChild(styles);

        callback(id);
    };

    overlay.innerHTML = ""
        + "<div class='test-social-form'>"
        + "    <div>Fake login</div>"
        + `    <div class='test-social-current-user'>Current user id:<br>${connector.platform.getUserID()}</div>`
        + "    <div class='test-social-choose-user'>"
        + "        <div>Choose user:</div>"
        + "        <div id='test-social-choose-user-list'></div>"
        + "    </div>"
        + "    <div class='test-social-custom-user'>"
        + "        <div>Or enter custom id:</div>"
        + "        <input type='text' id='test-social-custom-user-input'>"
        + "    </div>"
        + "    <div id='test-social-login'>Login</div>"
        + "    <button id='test-social-close'>&times;</button>"
        + "</div>";

    const users = document.getElementById("test-social-choose-user-list");

    Object.values(TestSocial.USERS).forEach((user) => {
        const pre = document.createElement("pre");
        pre.innerText = `${user.firstName}\n${user.lastName}`;
        pre.style = "margin: 0;";

        const element = document.createElement("div");
        element.append(pre);
        element.style.width = "100px";
        element.onclick = function () {
            onLogin(user.id);
        };
        users.append(element);
    });

    const login = document.getElementById("test-social-login");
    login.onclick = function () {
        const input = document.getElementById("test-social-custom-user-input");
        onLogin(input.value);
    };

    const close = document.getElementById("test-social-close");
    close.onclick = function () {
        onLogin(undefined);
    };
};

TestSocial.isAppropriate = function () {
    return connector.platform.oneOf(connector.TEST);
};

TestSocial.USERS = {
    "9496127578": {
        name: "Jason Carter",
        firstName: "Jason",
        lastName: "Carter",
        avatar: "https://pay.zareefgaming.com/example/avatars/avatar_alpha.png"
    },
    "5305839203": {
        name: "Lauren Brooks",
        firstName: "Lauren",
        lastName: "Brooks",
        avatar: "https://pay.zareefgaming.com/example/avatars/avatar_beta.png"
    },
    "3850193653": {
        name: "Emily Reynolds",
        firstName: "Emily",
        lastName: "Reynolds",
        avatar: "https://pay.zareefgaming.com/example/avatars/avatar_gamma.png"
    }
};

Object.keys(TestSocial.USERS).forEach((id) => {
    TestSocial.USERS[id].id = id;
});

TestSocial.INVITABLE_USERS = {
    invitable_1: {
        name: "Invitable1",
        avatar: "https://graph.facebook.com/100001008129789/picture?height=200&width=200"
    },
    invitable_2: {
        name: "Invitable2",
        avatar: "https://graph.facebook.com/100011706990070/picture?height=200&width=200"
    },
    invitable_3: {
        name: "Invitable3",
        avatar: "https://graph.facebook.com/100001575006940/picture?height=200&width=200"
    },
    invitable_4: {
        name: "Invitable4",
        avatar: "https://graph.facebook.com/100000318466656/picture?height=200&width=200"
    }
};

Object.keys(TestSocial.INVITABLE_USERS).forEach((id) => {
    TestSocial.INVITABLE_USERS[id].id = id;
});
